import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthorizeService } from '../../services/authorize.service';
import { VehicleService } from '../../services/vehicle.service';
import * as GarageActions from '../actions/garage.actions';

@Injectable()
export class GarageEffects {
  private actions$ = inject(Actions);
  private authorizeService = inject(AuthorizeService);
  private vehicleService = inject(VehicleService);

  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GarageActions.loadUsers),
      switchMap(() =>
        this.authorizeService.getUsers().pipe(
          map((users) => GarageActions.loadUsersSuccess({ users })),
          catchError((error) => of(GarageActions.loadUsersFailure({ error })))
        )
      )
    )
  );

  searchUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GarageActions.searchUsers),
      switchMap(({ pageNum, pageSize, query }) =>
        this.authorizeService.searchUsers(pageNum, pageSize, query).pipe(
          map((users) => GarageActions.searchUsersSuccess({ users })),
          catchError((error) => of(GarageActions.searchUsersFailure({ error })))
        )
      )
    )
  );

  loadVehicles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GarageActions.loadVehicles),
      switchMap(({ params }) => {
        return this.vehicleService.getAllVehiclesWithImages(params).pipe(
          map((response) => {
            return GarageActions.loadVehiclesSuccess({
              vehicles: response.data,
              currentPage: response.pageNum,
              pageSize: response.pageSize,
              totalPages: response.totalPages
            });
          }),
          catchError((error) => {
            return of(GarageActions.loadVehiclesFailure({ error }));
          })
        );
      })
    )
  );

  loadVehicleDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GarageActions.loadVehicleDetail),
      switchMap(({ vehicleId }) =>
        this.vehicleService.getVehicleWithImages(vehicleId).pipe(
          map((vehicle) => GarageActions.loadVehicleDetailSuccess({ vehicleId, vehicle })),
          catchError((error) => of(GarageActions.loadVehicleDetailFailure({ vehicleId, error })))
        )
      )
    )
  );
}
